/** Delays between handler delivery attempts (after attempts 1–7). */
export const HANDLER_RETRY_DELAYS_MS = [
  60_000, // 1m
  300_000, // 5m
  1_800_000, // 30m
  3_600_000, // 1h
  21_600_000, // 6h
  86_400_000, // 24h
  172_800_000, // 48h
] as const;

export const HANDLER_MAX_ATTEMPTS = HANDLER_RETRY_DELAYS_MS.length + 1;

export const HANDLER_FETCH_TIMEOUT_MS = 30_000;

export function handlerRetryDelayMs(failedAttempt: number): number | null {
  if (failedAttempt < 1 || failedAttempt >= HANDLER_MAX_ATTEMPTS) {
    return null;
  }
  return HANDLER_RETRY_DELAYS_MS[failedAttempt - 1] ?? null;
}

export function isRetriableHandlerFailure(
  statusCode: number | undefined,
  _error?: string
): boolean {
  if (statusCode === undefined) {
    return true;
  }
  if (statusCode >= 200 && statusCode < 300) {
    return false;
  }
  if (statusCode === 408 || statusCode === 429) {
    return true;
  }
  if (statusCode >= 500) {
    return true;
  }
  return false;
}
